import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InputField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '10px',
    color: theme.palette.text.primary, // Text color
    // Новое решение с :has() селектором
    '&:has(> input:-webkit-autofill)': {
      backgroundColor: `#e7f0fe !important`,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.primary, // Label color

    '&.Mui-focused': {
      color: theme.palette.text.primary, // Focused label color
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.customColors.primary10, // Default border color
    },
    '&:hover fieldset': {
      borderColor: theme.customColors.primary100, // Hover border color
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.customColors.primary100, // Focused border color
    },
  },
}));
